import { Button, FeaturedIcon, Icons } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import { useRouter } from 'next/router';
import { EmptyStateV2 } from '../../components/empty-state/EmptyStateV2';
import { ShareholdersTable } from './ShareholdersTable';
import SharesInformation from './SharesInformation';
import { useOwnershipInfo } from './useOwnershipInfo';

export const Ownership = ({
  businessEntityId,
  disabled = false,
  banner,
  className,
  editRoute,
}: {
  businessEntityId: number;
  disabled?: boolean;
  banner?: React.ReactNode;
  className?: string;
  editRoute?: string;
}) => {
  const { isCapTablePopulated } = useOwnershipInfo({ businessEntityId });
  const router = useRouter();

  const handleEditOwnership = () => {
    router.push(editRoute || `/corporation/${businessEntityId}/ownership`);
  };

  return (
    <div
      className={cn(
        'h-[calc(100vh-40px)] flex flex-col gap-4xl overflow-y-auto',
        className
      )}
    >
      <div className="flex justify-between items-center">
        <h3 className="display-xs-bold">Ownership</h3>

        {!disabled ? (
          <Button
            size="sm"
            variant={isCapTablePopulated ? 'secondary' : 'primary'}
            onClick={handleEditOwnership}
          >
            {isCapTablePopulated ? (
              <Icons.Pencil02 className="size-4" />
            ) : (
              <Icons.Plus className="size-4" />
            )}
            <span>
              {isCapTablePopulated
                ? 'Edit ownership details'
                : 'Add ownership details'}
            </span>
          </Button>
        ) : null}
      </div>
      {banner}
      {isCapTablePopulated ? (
        <div className="flex flex-col gap-6xl">
          <SharesInformation businessEntityId={businessEntityId} />
          <ShareholdersTable businessEntityId={businessEntityId} />
        </div>
      ) : (
        <EmptyStateV2
          title="No ownership details"
          description="Any ownership associated with this entity will appear here."
          icon={<FeaturedIcon icon={<Icons.SearchLg />} />}
          className="max-h-[248px]"
        />
      )}
    </div>
  );
};
